import { useMutation } from '@apollo/client';
import AuthLayout from '../Components/AuthLayout';
import LoginForm from '../Components/Forms/LoginForm';
import useBackendErrorMessage from 'hooks/useBackendErrorMessage';
import useAutoLogout from '../hooks/useAutoLogout';
import { LOGIN } from 'graphql/auth/mutations/auth.mutations';
import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Login: FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Logout user when still found
  useAutoLogout();

  const setBackendError = useBackendErrorMessage();
  const [login] = useMutation<null, { email: string; password: string }>(LOGIN, {
    onError: error => {
      setBackendError(
        error.message,
        'We are experiencing issues logging you in. Please try again or contact our support.'
      );
    },
    onCompleted: () => {
      const redirect = state?.redirect || '/';
      navigate(redirect);
    },
    fetchPolicy: 'no-cache',
  });

  const onSubmit = ({ email, password }: { email: string; password: string }) => {
    return login({
      variables: { email, password },
    });
  };

  return (
    <AuthLayout title="Login">
      <LoginForm onSubmit={onSubmit} />
    </AuthLayout>
  );
};

export default Login;
